module.exports = __webpack_public_path__ + "assets/img/block-right-d7581f4a.png";